/** Bonus kartındaki vurgu satırı ("Yeni üyelere özel" gibi).
 *
 * Metin yönetim panelinden yazılabilir ve satır tümden kapatılabilir
 * (`highlight_note`, `highlight_note_enabled`). Metin boş bırakılırsa
 * kampanya türünden otomatik üretilir. Süzgeç bilinçli olarak tek yerdedir:
 * promosyon kartı, bonus detayı ve paneldeki önizleme aynı sonucu vermelidir.
 */

export const AUTO_HIGHLIGHT_TRIAL = 'Yeni üyelere özel';
export const AUTO_HIGHLIGHT_FIRST_DEPOSIT =
  'Yalnızca yeni üyelerin ilk yatırımına özel';

export const AUTO_HIGHLIGHT_AUTO_AWARD =
  'Yatırımınız onaylanınca otomatik tanımlanır';

/** Yönetici metin girmediğinde kullanılacak varsayılan not. */
export const autoBonusHighlight = (bonus) => {
  if (bonus?.auto_award) return AUTO_HIGHLIGHT_AUTO_AWARD;
  if (!bonus?.new_members_only) return '';
  return bonus?.is_trial_bonus
    ? AUTO_HIGHLIGHT_TRIAL
    : AUTO_HIGHLIGHT_FIRST_DEPOSIT;
};

/** Kartta gerçekten çizilecek not; boş string = satır çizilmez. */
export const bonusHighlight = (bonus) => {
  if (bonus?.highlight_note_enabled === false) return '';
  const manual = String(bonus?.highlight_note || '').trim();
  return manual || autoBonusHighlight(bonus);
};
